module.exports = __webpack_public_path__ + "img/alt4.8d1f19e4.jpg";